import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { AuthService } from 'src/app/core/auth/services/auth.service';
import { User } from 'src/app/core/auth/models';
import { StorageService } from 'src/app/utils/services/storage.service';

@Component({
  standalone: false,
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit, OnDestroy {
  user!: User | undefined;
  organization!: string;
  hideUserInfo: boolean = false;
  private unsubscribe$ = new Subject<void>();

  constructor(
    private authService: AuthService, 
    private router: Router, 
    private cd: ChangeDetectorRef,
    private storage: StorageService
  ) {}

  ngOnInit(): void {
    this.hideUserInfo = this.router.url.includes('/auth/select-organization');
    this.organization = this.storage.get("lastOrganization") ?? "";
    this.authService.$user.pipe(takeUntil(this.unsubscribe$)).subscribe(user => {
      this.user = user;
    });

    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd),
      takeUntil(this.unsubscribe$)
    ).subscribe(() => {
      this.hideUserInfo = this.router.url.includes('/auth/select-organization');
      this.organization = this.storage.get("lastOrganization") ?? "";
      this.cd.detectChanges();
    });
  }

  changeOrganization(): void {
    this.router.navigateByUrl('/auth/select-organization');
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }
}
